module.exports = require("react-split-pane");


//////////////////
// WEBPACK FOOTER
// external "react-split-pane"
// module id = 599
// module chunks = 0